<template>
    
    <div class="ystk-box">
        <div>
            <van-icon size="20" name="cross" @click="close" />
        </div>
        <div>个人信息与隐私保护条款</div>
        <div>尊敬的用户：</div>
        <div>1、本服务页面及本协议由东航期货有限责任公司（以下简称“我方”）提供。</div>
        <div>2、我方将按照本条款的规定收集、处理您的个人信息。本协议可能涉及您个人信息权益的重要约定，请您在提供个人信息前仔细阅读。一旦您在页面上提交了相关信息，即视为您同意本协议的全部内容。</div>
        <div>3、为了进一步向您提供商品或服务的相关信息，了解您的需求以更好地实现本广告的推广目的，参与相关营销活动等，需要您按页面的表单提交相关信息（简称“客户信息”），我方承诺将严格依照相关法律规定收集、处理您提交的信息。您有权拒绝提供上述信息，但可能无法获取进一步的广告信息。如您提供了上述信息，您应保证所有信息真实、准确、完整、有效。</div>
        <div>4、您同意我方可基于以下目的或原因自行或委托、安排广告后台对您的个人信息进行收集或处理：（1）安排人员与您取得联系，向您提供更有价值的信息，实现广告推广目的；（2）用于广告投放、广告投放效果优化、广告归因、广告监测等广告业务合作；（3）用于商业性分析和洞察；（4）核验信息真实性；（5）其他法律法规许可的目的。</div>
        <div>5、我方将采取有效措施保障您的个人信息安全，因我方收集、处理您的个人信息产生的一切问题，由我方处理、负责。</div>
        <div>6、若您是未满18周岁的未成年人，请在您的父母或其他监护人监护、指导下共同阅读本协议。</div>
        <div>7、如您有任何投诉、建议或咨询，或有任何基于法律法规规定的权利请求，可通过如下方式联系我们：</div>
        <div>（1）客服热线4008-889-889</div>
        <div>（2）客服邮箱service@kiiik.com</div>
        <div>对本条款的问题，您可以将您的问题寄到如下地址：上海市闵行区吴中路686号D座16楼东航期货有限责任公司 合规及风险管理部（收） 邮编：201103</div>
        <div>我们将尽快审核所涉及的问题，并在验证您的用户身份后的十五天内予以回复。</div>
        <div>9、我司拥有对上述条款的最终解释权。</div>
        <div>东航期货有限责任公司</div>
    </div>
</template>
<script>
    /* eslint-disable */
    export default {
       methods: {
            close() {
                this.$emit('close', false)
            }
       } 
    }
</script>
<style scoped>
    .ystk-box {
        height: 70vh;
        width: 95%;
        margin: 0 auto;
        background-color: #dddddd;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
    }
    .ystk-box div {
        padding: 10px 15px;
        font-size: 14px;
        text-indent:28px;
        font-family: SourceHanSansCN-Bold;
    }
    .ystk-box div:nth-child(1) {
        text-align: right;
    }
    .ystk-box div:nth-child(2) {
        text-align: center;
    }
    .ystk-box div:last-child {
        text-align: right;
    }
</style>



// WEBPACK FOOTER //
// ystk.vue?1e1bd244